class LWPortret extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        const href = this.getAttribute('href') || '#';
        const src = this.getAttribute('src') || '';
        const naam = this.getAttribute('naam') || '';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                /* Zorgt dat het portret nooit ieniemini wordt */
                min-width: 140px; 
                width: 100%;
            }

            .portret-link {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-decoration: none;
                color: inherit;
                text-align: center;
            }

            .img-container {
                width: 100%;
                /* Gebruik max-width om te voorkomen dat ze op desktop gigantisch worden */
                max-width: 250px; 
                aspect-ratio: 1 / 1;
                border-radius: 50%;
                overflow: hidden;
                margin-bottom: 12px;
                background: #eee;
                border: 2px solid black;
                /* Fix voor sommige browsers die cirkels niet lekker clippen bij zoom */
                -webkit-mask-image: -webkit-radial-gradient(white, black);
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
                transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            }

            .portret-link:hover img {
                transform: scale(1.1);
            }

            p {
                margin: 0;
                font-size: 16px; /* Iets kleiner op mobiel vaak prettiger */
                font-weight: 700;
                line-height: 1.2;
                word-wrap: break-word; /* Voorkomt dat lange namen uit de kolom breken */
            }

            @media (min-width: 768px) {
                p { font-size: 18px; }
            }
        </style>

        <a href="${href}" class="portret-link">
            <div class="img-container">
                <img src="${src}" alt="${naam}">
            </div>
            <p>${naam}</p>
        </a>
        `;
    }
}
customElements.define('lw-portret', LWPortret);